import React, { useMemo, useState } from "react";
import style from "./mianslider.module.css";
import { Fade } from "react-slideshow-image";
import classNames from "classnames";
import "react-slideshow-image/dist/styles.css";
import { IoArrowForwardCircleSharp } from "react-icons/io5";
import { RiInstagramFill } from "react-icons/ri";
import { FaFacebookF, FaYoutube } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDirection } from "shared/utils/DirectionContext";

const MainSlider = () => {
  const navigate = useNavigate();
  const { t }: any = useTranslation();
  const { isRtl } = useDirection();

  const [index, setIndex] = useState(0);

  const handleGoTreatment = () => navigate("/treatment");
  const handleGoContactUs = () => navigate("/freeOPD");
  const handleIndexChange = (i: number) => setIndex(i);

  const rtlStyle: any = isRtl
    ? {
        display: "flex",
        flexDirection: "row-reverse",
        gap: "10px",
        alignItems: "center",
      }
    : undefined;

  const getIconTransform = () =>
    isRtl ? { transform: "rotate(-180deg)" } : undefined;

  const SliderButtons = () => (
    <div className={style.flxcenter} style={{ marginTop: "40px" }}>
      <button
        className={style.Treatment}
        onClick={handleGoTreatment}
        style={rtlStyle}
      >
        <p>{t("findTreatments")}</p>
        <IoArrowForwardCircleSharp
          className={style.Icon}
          style={getIconTransform()}
        />
      </button>
      <button
        className={style.OPd}
        onClick={handleGoContactUs}
        style={rtlStyle}
      >
        <p>{t("freeOpd")}</p>
        <IoArrowForwardCircleSharp
          className={style.Iconm2}
          style={getIconTransform()}
        />
      </button>
    </div>
  );

  const sliderButtons = useMemo(() => <SliderButtons />, [isRtl, t]);

  const fadeImages = useMemo(
    () => [
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/meditourglobal-ea15d.appspot.com/o/assets%2FFirstSlide.jpg?alt=media&token=b6aa9cc1-8b6d-4fc9-8c87-8b7da7f7570b",
        heading: (
          <div className={style.flxCenter}>
            <p className={style.Nature1}>{t("nature")},</p>
            <p className={classNames(style.orange, style.heals)}>
              {t("heals")}
            </p>
          </div>
        ),
        text: t("natureHealsContent"),
        weight: "500",
        color: "#FF7631",
        family: "Nature",
        botton: sliderButtons,
      },
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/meditourglobal-ea15d.appspot.com/o/assets%2FSecondSlide.jpg?alt=media&token=e9ddcf35-223e-4220-9d34-0ebfc8f82e9d",
        heading: (
          <div className={classNames(style.flxh)}>
            <p className={classNames(style.white, style.headingSizetoExcel)}>
              {t("committed")}
            </p>
            <p className={classNames(style.orange, style.headingSizetoExcel)}>
              {t("excellence")}
            </p>
          </div>
        ),
        text: t("committedContent"),
        weight: "400",
        color: "#FF7631",
        family: "Poppins",
        botton: sliderButtons,
      },
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/meditourglobal-ea15d.appspot.com/o/assets%2FThirdSlide.jpg?alt=media&token=e06c063c-18e6-4b38-ae20-5f5f581741af",
        heading: (
          <div className={classNames(style.flxh, style.headingSize)}>
            <p className={style.white}>{t("we")}</p>
            <p className={style.orange}>{t("care")}</p>
          </div>
        ),
        text: t("weCareContent"),
        weight: "400",
        color: "#FF7631",
        family: "Poppins",
        botton: sliderButtons,
      },
    ],
    [t, sliderButtons]
  );

  return (
    <div className={style.slidecontainer}>
      <Fade
        autoplay
        duration={10000}
        transitionDuration={2000}
        pauseOnHover={false}
        arrows={false}
        onChange={handleIndexChange}
      >
        {fadeImages.map((item, idx) => (
          <div key={idx}>
            <div className={style.imagecontainer}>
              <img
                src={item.image}
                className={style.imgsss}
                alt={`slide ${idx}`}
              />
              <div className={style.textoverlay}>
                <div
                  className={style.overlayHeading}
                  style={{ fontFamily: item.family }}
                >
                  {item.heading}
                </div>
                <p
                  className={style.overlaytext}
                  style={{ fontWeight: item.weight }}
                >
                  {item.text}
                </p>
                <div>{item.botton}</div>
                <div className={style.bottomSection}>
                  <div className={style.iconsGroup}>
                    <a
                      href="https://www.instagram.com/themeditour.global/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <RiInstagramFill className={style.SocialIcon} />
                    </a>
                    <div className={style.borderright}></div>
                    <a
                      href="https://www.facebook.com/profile.php?id=61560461618333"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebookF className={style.SocialIcon} />
                    </a>
                    <div className={style.borderright}></div>
                    <a
                      href="https://www.youtube.com/@themeditour.global"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaYoutube className={style.SocialIcon} />
                    </a>
                  </div>

                  <div className={style.dotsGroup}>
                    {fadeImages.map((_, dotIdx) => (
                      <React.Fragment key={dotIdx}>
                        <div className={style.dots}>
                          <div
                            className={
                              index === dotIdx ? style.dotsFillActive : ""
                            }
                          ></div>
                        </div>
                        {dotIdx !== fadeImages.length - 1 && (
                          <div className={style.borderright}></div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Fade>
    </div>
  );
};

export default MainSlider;
